import { render, staticRenderFns } from "./PageVerifyPhoto.vue?vue&type=template&id=0f115786&"
import script from "./PageVerifyPhoto.vue?vue&type=script&lang=js&"
export * from "./PageVerifyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./PageVerifyPhoto.vue?vue&type=style&index=0&id=0f115786&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports